module.exports = __webpack_public_path__ + "media/bitdabg.2c06ec00.mp4";